export const Divider: React.FC = () => (
  <div className="h-full flex items-center">
    <div
      className="w-1 h-12"
      style={{
        backgroundColor: '#C4C4C4',
      }}
    />
  </div>
);
